import { render, staticRenderFns } from "./PromotionSettingListPage.vue?vue&type=template&id=27b1728e&scoped=true"
import script from "./PromotionSettingListPage.vue?vue&type=script&lang=js"
export * from "./PromotionSettingListPage.vue?vue&type=script&lang=js"
import style0 from "./PromotionSettingListPage.vue?vue&type=style&index=0&id=27b1728e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b1728e",
  null
  
)

export default component.exports